// extracted by mini-css-extract-plugin
export default {"tooltip":"cR-z","arrow":"dR-z"};